module.exports = __webpack_public_path__ + "static/media/primary-logo.de82c7ce.svg";